module.exports = __webpack_public_path__ + "static/media/bgtwo.62882364.png";